export default class Feature {
  id?: string;

  name: string;

  businessUnitId: string;

  constructor(obj: any) {
    this.id = obj.id || null;
    this.name = obj.name || null;
    this.businessUnitId = obj.businessUnitId || null;
  }

  public static of(obj: any): Feature {
    return new Feature(obj || {});
  }

  public static ofList(obj: any[]): Feature[] {
    return obj.map(this.of);
  }
}
